import LoadingScreen from './component/LoadingScreen.vue';
import LoadingManager from './model/LoadingManager';
import loadingModule from './module/loadingModule';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    const loadingManager = new LoadingManager(options.store);
    options.store.registerModule('loading', loadingModule);

    // After creating loading manager and registering store for loading
    // we need to update store.
    loadingManager.update();

    Vue.component('loading-component', LoadingScreen);

    Vue.mixin({
      // Add component lifecycle hooks or properties.
      computed: {
        isLoaded() {
          return options.store.state.loading.isLoaded;
        },
      },
    });

    /* eslint no-param-reassign: 0 */
    Vue.prototype.$loadingManager = loadingManager;
    /* eslint no-param-reassign: 1 */
  },
};
